import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import { liveDiffUnsupportedReason } from '../../../util/engine-support';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

let dictionaryList;

class ManageDataDictionary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
      dictionaryFilterCriteria:"",
      emptyState:"You do not have any Data Dictionaries.",
      deleteDictionaryVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }

  componentDidMount = () => {
    this.setState({
      dictionaryFilterCriteria:""
    });
  }

  editDictionary = (dictionary) => {
    this.props.onClick({dictionary});
  }

  modalClose = () => {
    this.setState({
      modalOpen:false
    });
  }

  modalConfirm = () => {
    this.setState({
      modalOpen:false
    });
    const instanceId = this.state.deleteDictionaryVal.instance_id || this.state.deleteDictionaryVal.instanceId || this.state.deleteDictionaryVal.id;
    const instanceName = this.state.deleteDictionaryVal.instance_name || this.state.deleteDictionaryVal.instanceName || this.state.deleteDictionaryVal.name;
    
    let deleteObj = {
      dictionaryId: instanceId,
      dictionaryName: instanceName
    };
    this.props.deleteDictionary(deleteObj);
  }

  deleteItem = (dictionary) => {
    const instanceName = dictionary.instance_name || dictionary.instanceName || dictionary.name;
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      modalOpen:true,
      modalTitle:"Delete Dictionary",
      modalContent:"Are you sure you want to delete \"" + instanceName + "\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteDictionaryVal:dictionary
    });
  }

  refreshDictionary = (dictionary) => {
    this.setState({ menuAnchorEl: null, menuOpenId: null });
    if (liveDiffUnsupportedReason(dictionary)) return;
    const instanceId = dictionary.instance_id || dictionary.instanceId || dictionary.id;
    if (this.props.onRefresh) {
      this.props.onRefresh(instanceId, dictionary);
    }
  }

  createNewDictionary = () => {
    this.props.onClick('new');
  }

  render() {
    const {isLoading} = this.props;
    let manageDictionaryContent, dictionaryListContent;
    if(isLoading.includes('dictionarylist')){
      manageDictionaryContent = <Preloader loading={true} />;
    }
    else if(this.props.dictionaryList !== undefined){
      const filterCriteria = this.state.dictionaryFilterCriteria;
      dictionaryList = this.props.dictionaryList.filter(function (e) {
        const instanceName = e?.instanceName || e?.name || '';
        return instanceName.toLowerCase().includes(filterCriteria.toLowerCase());
      });


      if (dictionaryList.length > 0) {
        dictionaryListContent = <table className='manage-ruleset-table' data-testid="dd-instance-table">
          <tbody>
            {dictionaryList.map((dictionary, index) => <tr key={index} data-testid="dd-instance-row" data-instance-name={dictionary.instanceName || dictionary.name || ''}>
              <td onClick={this.editDictionary.bind(this, dictionary)} className='user' data-testid="dd-instance-name">{dictionary.instanceName}</td>
              <td>
                <div className='actions-menu'>
                  <IconButton data-testid="dd-instance-menu" onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, menuOpenId: index })}>
                    <i className='material-icons'>more_horiz</i>
                  </IconButton>
                  <Menu 
                    anchorEl={this.state.menuAnchorEl} 
                    open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === index} 
                    onClose={() => this.setState({ menuAnchorEl: null, menuOpenId: null })}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    transformOrigin={{horizontal: 'right', vertical: 'top'}}
                  >
                    {/* Refresh diffs against the live source through a MySQL-only
                        engine; on MSSQL it fails with a raw protocol error, so it is
                        disabled with a reason rather than left to blow up. */}
                    <MenuItem className='wl-group-card-menu' data-testid="dd-instance-refresh"
                      disabled={!!liveDiffUnsupportedReason(dictionary)}
                      title={liveDiffUnsupportedReason(dictionary)}
                      onClick={this.refreshDictionary.bind(this, dictionary)}>
                      <span className='material-icons' style={{ marginRight: 8, fontSize: 18 }}>sync</span>
                      {liveDiffUnsupportedReason(dictionary) ? 'Refresh — not supported for MS SQL Server' : 'Refresh'}
                    </MenuItem>
                    <MenuItem className='wl-group-card-menu' data-testid="dd-instance-delete"
                      onClick={this.deleteItem.bind(this, dictionary)}>Delete</MenuItem>
                  </Menu>
                </div>
              </td>
            </tr>)}
          </tbody>
        </table>
      } else {
        dictionaryListContent = <EmptyState className="margin-top-0" message={this.state.emptyState} data-testid="dd-empty-state" />
      }

      manageDictionaryContent = <Row>
        <Col sm={4} xs={6}>{dictionaryListContent}</Col>
        <Col sm={4} xs={6} className="manage-rule-buttons">
          <Button href="" onClick={this.createNewDictionary.bind(this)} className='createruleset-button' data-testid="dd-add-instance">Add to Dictionary</Button>
        </Col>
      </Row>
    }
    return (
      <div>
        <Modal
          open={this.state.modalOpen}
          title={this.state.modalTitle}
          content={this.state.modalContent}
          primaryButton={this.state.modalPrimaryButton}
          secondaryButton={this.state.modalSecondaryButton}
          close={this.modalClose}
          confirm={this.modalConfirm}
        />
        <div className="manage-ruleset">
          {manageDictionaryContent}
        </div>
      </div>
    );
  }
}

export default ManageDataDictionary;
